import React from "react";

import Alert from "components/Alert";

const SelfApprovalAlert = () => (
  <Alert
    type="warning"
    msg="You created this request. Another admin must approve or deny it."
  />
);

export default SelfApprovalAlert;
